<template>
  <div class="hello">
    <h1>{{msg}}: {{numKPIs}}</h1>
    <div class="row" style="padding-bottom: 30px">
      <div class="row col-lg-2 offset-lg-1">
        Frequency
        <select
          v-model="selectedFrequency"
          name="frequency"
          id="frequency"
          ref="frequency"
          @change="select()"
          class="form-control"
        >
          <option v-for="freq in frequencies" :value="freq.text">{{freq.text}}</option>
        </select>
      </div>
      <div class="row col col-lg-2">
        Balanced Score Card
        <select
          v-model="selectedBsc"
          name="bsc"
          id="bsc"
          ref="bsc"
          @change="select()"
          class="form-control"
        >
          <option v-for="bsc in bscs" :value="bsc.text">{{bsc.text}}</option>
        </select>
      </div>
      <div class="row col col-lg-2">
        Teams
        <select
          v-model="selectedTeam"
          name="team"
          id="team"
          ref="team"
          @change="select()"
          class="form-control"
        >
          <option v-for="team in teams" :value="team.text">{{team.text}}</option>
        </select>
      </div>
      <div class="row col col-lg-2">
        Sectors
        <select
          v-model="selectedSector"
          name="team"
          id="team"
          ref="team"
          @change="select()"
          class="form-control"
        >
          <option v-for="sector in sectors" :value="sector.text">{{sector.text}}</option>
        </select>
      </div>
      <div class="row col col-lg-2">
        Strategy
        <select
          v-model="selectedStrategicObjective"
          name="team"
          id="team"
          ref="team"
          @change="select()"
          class="form-control"
        >
          <option
            v-for="strategicObjective in strategicObjectives"
            :value="strategicObjective.text"
          >{{strategicObjective.text}}</option>
        </select>
      </div>
    </div>
    <div class="results">
      <ul>
        <li v-for="kpi in kpis">
          <div class="kpi-row">
            <div class="row">
                <div class="col col-lg-12">
                    <h4>{{kpi.text}}</h4>
                </div>
            </div>
            <div class="row">
              <div class="col col-lg-2">{{kpi.frequency}}</div>
              <div class="col col-lg-2">{{kpi.bsc}}</div>
              <div class="col col-lg-2">{{kpi.teams}}</div>
              <div class="col col-lg-2">{{kpi.sectors}}</div>
              <div class="col col-lg-2">{{kpi.strategicObjective}}</div>
            </div>

          </div>
           <!-- <hr style="height:1px; border:none; color:#000; background-color:#000; width:100%; text-align:left; margin: 0 auto 0 0;"> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  data() {
    return {
      numKPIs: 346,
      selectedFrequency: "",
      selectedBsc: "",
      selectedTeam: "",
      selectedSector: "",
      selectedStrategicObjective: "",
      frequencies: [
        { text: "" },
        { text: "Weekly" },
        { text: "Quarterly" },
        { text: "Monthly" },
        { text: "Weekly/ Monthly" },
        { text: "When audits performed" },
        { text: "Periodically" },
        { text: "Daily and in some cases 24/7" },
        { text: "Daily" },
        { text: "Three to four times a year and in some cases continuously" },
        { text: "Two times a year" },
        { text: "Every employee survey (three to four times a year)" },
        { text: "Periodic survey of local community’s perception of company" },
        { text: "When survey performed" },
        { text: "After the performance review round" },
        { text: "Six monthly" },
        { text: "Weekly after the employee survey" },
        { text: "From staff survey" }
      ],
      bscs: [
        { text: "" },
        { text: "Customer satisfaction" },
        { text: "Employee (Other)" },
        { text: "Employee satisfaction" },
        { text: "Environment" },
        { text: "Environment/ Community" },
        { text: "Financial" },
        { text: "Internal process" },
        { text: "Learning and growth" }
      ],
      teams: [
        { text: "" },
        { text: "Sales and Marketing" },
        { text: "Production" },
        { text: "Sales" },
        { text: "Quality assurance (QA) team" },
        { text: "Sales and Marketing, QA team" },
        { text: "Accounting" },
        { text: "Sales and back office teams enter- ing orders" },
        { text: "Information technology (IT) commu- nications" },
        { text: "Project" },
        { text: "HR" },
        { text: "PR" },
        { text: "All service teams" },
        { text: "Operations" },
        { text: "IT" },
        { text: "All teams" },
        { text: "Production control, IT" },
        { text: "QA" }
      ],
      sectors: [
        { text: "" },
        { text: "All private sector" },
        { text: "All sectors" },
        { text: "Manufacturing" },
        { text: "Service" },
        { text: "Critical services sector" },
        { text: "Retail" },
        { text: "Service, manufacturing" }
      ],
      strategicObjectives: [
        { text: "" },
        { text: "Increase profitability" },
        { text: "Efficient operations" },
        {
          text:
            "Retention of customers/minimize negative comment in the marketplace"
        },
        { text: "Long-term relationship with profitable customers" },
        { text: "More reliable products" },
        { text: "Minimize negative comment in the marketplace" },
        { text: "Retention of customers/increase sales" },
        { text: "Improve employee satisfaction and productivity" },
        { text: "Desirable place to work" },
        {
          text:
            "Happy employees make happy customers, which make happy shareholders"
        },
        { text: "Working well with the community and environment" },
        { text: "Reducing environmental impact" },
        { text: "Positive public perception" },
        { text: "Increase sales" },
        { text: "Innovation" },
        { text: "Skilled and experienced workforce" },
        { text: "Healthy and safe work environment" },
        { text: "Maintain supplier relationships" }
      ],
      kpis2: [
        {
          text: "Dollar revenue gained from top customers in the week ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Percentage of customers with key attributes (ones that generate most profit) ",
          frequency: "Quarterly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Percentage of successful/unsuccessful tenders ",
          frequency: "Quarterly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Actual delivery date versus promised date ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Production",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Average customer size by category (category A being the top 20% of customers) ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Average time from customer enquiry to sales team response ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Average time to resolve complaints, to get credits for product quality problems, etc. ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Sales",
          sectors: "All private sector",
          strategicObjective:
            "Retention of customers/minimize negative comment in the marketplace"
        },
        {
          text: "Number of stock outs ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Production",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Brand image index (%) based from market research ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Cost of quality correction rework, rejects, warrantees, returns and allowances, inspection labor, and equipment, complaint processing costs ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Quality assurance (QA) team",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Customer acquisition (rate business unit attracts or wins new customers or business) ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Customer loyalty index (percentage of customer retention within customer categories) ",
          frequency: "Quarterly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Long-term relationship with profitable customers"
        },
        {
          text: "Number of customer service initial inquiries to follow-up ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increasing sales"
        },
        {
          text: "Customers lost (number or percentage) ",
          frequency: "Weekly/ Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Number of defect goods on installation (dead on arrival, including those that occur within the first 90 days of operation) ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing, QA team",
          sectors: "All private sector",
          strategicObjective: "More reliable products"
        },
        {
          text:
            "Sales of goods and services taken up by key customers top 10% to 20% of customers ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Direct communications to key customers in month (average number of contacts made with the key customers) ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Market share (proportion of business in a given market) ",
          frequency: "Quarterly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Number of customer referrals ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Number of incidents where senior management needed to instigate the remedial action ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number of proactive visits to top 10% of customers ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Number of client relationships producing significant net profit (over $X million) ",
          frequency: "Quarterly",
          bsc: "Customer satisfaction",
          teams: "Sales",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Number of contacts with customer during project and post-project wrap-up (major projects only) ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Project teams",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Number of credits/returns from key customers ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Number of visits made to core customers in a week ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Long-term relationship with profitable customers"
        },
        {
          text: "Order entry error rate ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Sales and back office teams enter- ing orders",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Order frequency (number of orders coming in per day/week) ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Orders canceled by reason (up to five categories) ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Sales",
          sectors: "All private sector",
          strategicObjective: "Long-term relationship with profitable customers"
        },
        {
          text: "Quality problems detected during product audits in the field ",
          frequency: "When audits performed",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing, QA team",
          sectors: "All private sector",
          strategicObjective: "Long-term relationship with profitable customers"
        },
        {
          text: "Customer satisfaction of top 10% of customers ",
          frequency: "Quarterly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Sales closed as a percentage of total sales proposals ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Service expense per customer category ",
          frequency: "Periodically",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Time elapsed since repeat business with category A customers (top 20% or top 10% customers) ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Abandon rate caller gives up ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Information technology (IT) commu- nications",
          sectors: "All sectors",
          strategicObjective: "Minimize negative comment in the marketplace"
        },
        {
          text:
            "Calls answered first time (not having to be transferred to another party) ",
          frequency: "Daily and in some cases 24/7",
          bsc: "Customer satisfaction",
          teams: "IT help desk, call centers",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Calls on hold longer than xx seconds ",
          frequency: "Daily and in some cases 24/7",
          bsc: "Customer satisfaction",
          teams: "IT commu- nications",
          sectors: "All sectors",
          strategicObjective: "Minimizing negative comment in the marketplace"
        },
        {
          text: "Complaints not resolved in two hours ",
          frequency: "Daily",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All sectors",
          strategicObjective:
            "Retention of customers/minimizing negative comment in the marketplace"
        },
        {
          text: "Complaints not resolved on first call ",
          frequency: "Daily",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All sectors",
          strategicObjective:
            "Retention of customers/minimizing negative comment in the marketplace"
        },
        {
          text: "Credit request processing time ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective:
            "Retention of customers/minimizing negative comment in the marketplace"
        },
        {
          text: "Key customer satisfaction ",
          frequency:
            "Three to four times a year and in some cases continuously",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing, service delivery teams",
          sectors: "All sectors",
          strategicObjective: "Retention of customers/increase sales"
        },
        {
          text: "In-house customer satisfaction percentage ",
          frequency: "Two times a year",
          bsc: "Customer satisfaction",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Improve employee satisfaction and productivity"
        },
        {
          text:
            "Late projects by manager (a list for internal projects and a list for client projects) ",
          frequency: "Weekly",
          bsc: "Customer satisfaction",
          teams: "Project teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number of variations to contract by type ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Number of Quality Service Guarantees issued (refund for poor service) ",
          frequency: "Weekly/ monthly",
          bsc: "Customer satisfaction",
          teams: "QA team",
          sectors: "All sectors",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Number of outstanding retention installments (monitoring close-out) ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Accounting team",
          sectors:
            "All sectors where customers retain a sum of money until satisfactory completion",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Orders shipped, which are complete and on time (delivery in full on time) ",
          frequency: "Daily and in some cases 24/7",
          bsc: "Customer satisfaction",
          teams: "Production control, dispatch, etc.",
          sectors: "All sectors who dispatch goods",
          strategicObjective: "Efficient operations"
        },
        {
          text: "The mean time between QA failures ",
          frequency: "Daily",
          bsc: "Customer satisfaction",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Actual client projects on time (percent of total) and cost versus budget (percent of budget) ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Project teams",
          sectors: "Service",
          strategicObjective:
            "Retention of customers/minimizing negative comment in the marketplace"
        },
        {
          text: "Time people waited in line ",
          frequency: "Daily",
          bsc: "Customer satisfaction",
          teams: "Sales",
          sectors: "Service",
          strategicObjective:
            "Retention of customers/minimizing negative comment in the marketplace"
        },
        {
          text:
            "Service requests outstanding (faults, works requests) at month end ",
          frequency: "Quarterly",
          bsc: "Customer satisfaction",
          teams: "Service teams",
          sectors: "Service",
          strategicObjective:
            "Retention of customers/minimizing negative comment in the marketplace"
        },
        {
          text:
            "Surrender ratio of equipment or service (where service or equipment is on a monthly contract) ",
          frequency: "Monthly",
          bsc: "Customer satisfaction",
          teams: "Sales and Marketing",
          sectors: "Service",
          strategicObjective: "Long-term relationship with profitable customers"
        },
        {
          text: "Number of applicants for employment at the company ",
          frequency: "Quarterly",
          bsc: "Employee (Other)",
          teams: "Human Resources (HR)",
          sectors: "All sectors",
          strategicObjective: "Desirable place to work"
        },
        {
          text: "Percentage of staff working flexible hours ",
          frequency: "Monthly",
          bsc: "Employee satisfaction",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective:
            "Happy employees make happy customers, which make happy shareholders"
        },
        {
          text: "Analysis of absenteeism ",
          frequency: "Monthly",
          bsc: "Employee satisfaction",
          teams: "HR, all teams",
          sectors: "All sectors",
          strategicObjective:
            "Happy employees make happy customers, which make happy shareholders"
        },
        {
          text: "Employee complaint resolution timelines and effectiveness ",
          frequency: "Monthly",
          bsc: "Employee satisfaction",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective:
            "Happy employees make happy customers, which make happy shareholders"
        },
        {
          text: "Employee satisfaction per survey ",
          frequency: "Every employee survey (three to four times a year)",
          bsc: "Employee satisfaction",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective:
            "Happy employees make happy customers, which make happy shareholders"
        },
        {
          text:
            "Number of employees who have received recognition in last week, two weeks, month ",
          frequency: "Weekly",
          bsc: "Employee satisfaction",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective:
            "Happy employees make happy customers, which make happy shareholders"
        },
        {
          text:
            "Empowerment index, number of staff and managers who say they are empowered (from staff survey) ",
          frequency: "Every employee survey (three to four times a year)",
          bsc: "Employee satisfaction",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective:
            "Happy employees make happy customers, which make happy shareholders"
        },
        {
          text: "Length of service of staff who have left ",
          frequency: "Monthly",
          bsc: "Employee satisfaction",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective:
            "Happy employees make happy customers, which make happy shareholders"
        },
        {
          text: "Number of days working overseas on jobs ",
          frequency: "Quarterly",
          bsc: "Employee satisfaction",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective:
            "Happy employees make happy customers, which make happy shareholders"
        },
        {
          text:
            "Number of recognition events and awards to staff planned for next four weeks, next eight weeks ",
          frequency: "Weekly",
          bsc: "Employee satisfaction",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective:
            "Happy employees make happy customers, which make happy shareholders"
        },
        {
          text:
            "Number of potential recruits that come from employee referrals ",
          frequency: "Quarterly",
          bsc: "Employee satisfaction",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective:
            "Happy employees make happy customers, which make happy shareholders"
        },
        {
          text: "Recruitment rating (survey on all new employees) ",
          frequency: "Every employee survey (three to four times a year)",
          bsc: "Employee satisfaction",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective:
            "Happy employees make happy customers, which make happy shareholders"
        },
        {
          text:
            "Satisfaction with a balanced working and nonworking life (from staff survey) ",
          frequency: "Every employee survey (three to four times a year)",
          bsc: "Employee satisfaction",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Attendance numbers for social club functions ",
          frequency: "Quarterly",
          bsc: "Employee satisfaction",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective:
            "Happy employees make happy customers, which make happy shareholders"
        },
        {
          text:
            "Staff turnover by type (resignations, end of contract, temporary staff, terminations) ",
          frequency: "Monthly",
          bsc: "Employee satisfaction",
          teams: "HR, all teams",
          sectors: "All sectors",
          strategicObjective:
            "Happy employees make happy customers, which make happy shareholders"
        },
        {
          text:
            "Community/environmental satisfaction index from external survey ",
          frequency:
            "Periodic survey of local community\\u00eds perception of company",
          bsc: "Environment",
          teams: "Public Relations",
          sectors: "All sectors",
          strategicObjective: "Working well with the community and environment"
        },
        {
          text: "Volunteer retention/recruitment ",
          frequency: "Monthly",
          bsc: "Environment",
          teams: "Operations",
          sectors: "Charity",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Emissions from production into the environment (number) ",
          frequency: "Weekly",
          bsc: "Environment",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Reducing environmental impact"
        },
        {
          text: "Energy consumed per unit, BTU/sales ",
          frequency: "Weekly",
          bsc: "Environment",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Reducing environmental impact"
        },
        {
          text: "Percentage of recycled material used as raw material input ",
          frequency: "Weekly",
          bsc: "Environment",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Reducing environmental impact"
        },
        {
          text: "Percentage of waste generated/recycled ",
          frequency: "Weekly",
          bsc: "Environment",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Reducing environmental impact"
        },
        {
          text: "Waste and scrap produced ",
          frequency: "Weekly",
          bsc: "Environment",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Reducing environmental impact"
        },
        {
          text:
            "Water consumption and/or discharge per production unit (or by per employee, or per sales dollar) ",
          frequency: "Weekly",
          bsc: "Environment",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Reducing environmental impact"
        },
        {
          text: "Number of employees involved in community activities ",
          frequency: "Quarterly",
          bsc: "Environment/ Community",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Working well with the community and environment"
        },
        {
          text: "Dollars donated to the community ",
          frequency: "Quarterly",
          bsc: "Environment/ Community",
          teams: "Public Relations (PR)",
          sectors: "All sectors",
          strategicObjective: "Positive public perception"
        },
        {
          text: "Percentage of local residents in total workforce ",
          frequency: "Quarterly",
          bsc: "Environment/ Community",
          teams: "PR",
          sectors: "All sectors",
          strategicObjective: "Positive public perception"
        },
        {
          text:
            "Entries to environment/community awards to be completed in next three months ",
          frequency: "Monthly",
          bsc: "Environment/ Community",
          teams: "Operations",
          sectors: "All sectors",
          strategicObjective: "Positive public perception"
        },
        {
          text: "Number of environmental complaints received in a week ",
          frequency: "Weekly",
          bsc: "Environment/ Community",
          teams: "PR",
          sectors: "All sectors",
          strategicObjective: "Positive public perception"
        },
        {
          text:
            "Number of external charity volunteers trained by company staff ",
          frequency: "Quarterly",
          bsc: "Environment",
          teams: "Operations",
          sectors: "Charity",
          strategicObjective: "Working well with the community and environment"
        },
        {
          text:
            "Number of firms employees involved in up-skilling local community organizations ",
          frequency: "Quarterly",
          bsc: "Environment/ Community",
          teams: "PR",
          sectors: "All sectors",
          strategicObjective: "Positive public perception"
        },
        {
          text: "Number of media coverage events ",
          frequency: "Monthly",
          bsc: "Environment/ Community",
          teams: "PR",
          sectors: "All sectors",
          strategicObjective: "Positive public perception"
        },
        {
          text: "Number of photos in paper ",
          frequency: "Monthly",
          bsc: "Environment/ Community",
          teams: "PR",
          sectors: "All sectors",
          strategicObjective: "Positive public perception"
        },
        {
          text: "Number of sponsorship projects undertaken by company ",
          frequency: "Quarterly",
          bsc: "Environment/ Community",
          teams: "PR",
          sectors: "All sectors",
          strategicObjective: "Positive public perception"
        },
        {
          text: "Number of students recruited for holiday work ",
          frequency: "Quarterly",
          bsc: "Environment/ Community",
          teams: "PR",
          sectors: "All sectors",
          strategicObjective: "Positive public perception"
        },
        {
          text:
            "Percentage of current projects that are environmentally friendly ",
          frequency: "Monthly",
          bsc: "Environment/ Community",
          teams: "PR",
          sectors: "Construction",
          strategicObjective: "Reducing environmental impact"
        },
        {
          text: "Percentage complete to percentage billed by job ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Operations",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Percentage of category A customers covered by partnership projects ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Percentage of customers paying cash up front on commencement of project ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Percentage of profitability per major project ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Percentage of sales that have arisen from cross-selling among business units ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Percentage of successful tenders ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Percentage of top ten customers\\u00ed business ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Accounts receivable turnover ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Average number of days spent as stock in hand ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Stock control",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Bad debt percentage to turnover ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Cash flow ($) ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Cash-to-cash cycle\\u00f1\\u00f1length of time from cash out to cash in ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Contribution to revenue, or contribution margin (%) ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Customer and product-line profitability ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Days in accounts payable ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Maintain supplier relationships"
        },
        {
          text: "Days in inventory ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Days sales in receivables ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Dealer profitability ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Dealer satisfaction survey ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Economic value added per employee ($) ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Gross margin by business ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Indirect expenses as a percentage of sales ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Marketing expense per customer ($) ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "Marketing",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Net income by business ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "New business by occurrence type (e.g., referrals, promotional drive, prospecting, website, etc.) ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Number of profitable customers ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Number of projects with all progress payments paid ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number of winning tenders that have created losses ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Operations",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Percentage revenues from new products or service ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase sales"
        },
        {
          text: "Profits from new products or business operations ($) ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Profits/employee ($) ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Return on capital employed ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Return on net asset value ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Return on equity ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Revenues/employee ($) ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Revenues/total assets (%) ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Sales by manager ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Sales growth rate by market segment ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Credit rating ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Debt-to-equity ratio ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Investment in development of new markets ($) ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "Sales",
          sectors: "All sectors",
          strategicObjective: "Innovation"
        },
        {
          text: "IT expense as a percentage of total administrative expense ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "IT, Accounting, or Finance",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "People/headquarters costs ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Percentage unprofitable customers ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Sales and Marketing",
          sectors: "All sectors",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Progress on major IS CAPEX projects ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "IT, Accounting, or Finance",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Teams expenditure profile for year to date (tracks actual and expected against planned expenditure profile for year) ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Total assets/employee ($) ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Value of work in progress ($) ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Operations",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Average cost of maintaining a customer account ($) ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "Operations",
          sectors: "Banking",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Value of mortgage offers ($) ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Operations",
          sectors: "Banking",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Value of personal loan advances ($) ",
          frequency: "Monthly",
          bsc: "Financial",
          teams: "Operations",
          sectors: "Banking",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Administrative expense as a percentage of gross premium ",
          frequency: "Quarterly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "Insurance",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Percentage chargeable work/nonrecoverable ",
          frequency: "Weekly",
          bsc: "Financial",
          teams: "All service teams",
          sectors: "Service",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Budgeted time against actual time on weekly basis ",
          frequency: "Weekly",
          bsc: "Financial",
          teams: "Accounting",
          sectors: "Service",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Percentage of brand dominance in market ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Percentage of invoices processed within the week ",
          frequency: "Monthly",
          bsc: "Internal Process",
          teams: "Operations",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Accuracy and completeness of specifications for orders ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Sales",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Average age of company patents (number) ",
          frequency: "Quarterly",
          bsc: "Internal Process",
          teams: "Research and development (R&D)",
          sectors: "All private sector",
          strategicObjective: "Innovation"
        },
        {
          text:
            "Changes to orders after initial placement controllable and uncontrollable ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Sales",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Excess inventory anything above normal requirements ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Inventory items above/below target limits ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Manufacturing cycle effectiveness processing/ throughput time ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Manufacturing process quality measures re-work (how many items make it through the process without being reworked at any stage) % ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Merchandise availability measure of inventory turns on selected key items ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Number of improvements made to existing products ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "All private sector",
          strategicObjective: "Innovation"
        },
        {
          text:
            "Number of profitable new products (over $XX and greater than X% gross margin) ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Outage hours per month ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Patents filed and issued that have been incorporated into products ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Percentage of products for which the first design of a device fully met the customer\\u00eds functional specification ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Potential revenue in sales pipeline ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Pricing accuracy ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Sales",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Product-development cycle time of major new projects ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Production amount that passes to next stage in production",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Production cycle time (time in each stage) ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Quality problems due to equipment failure ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Queue production time ratio ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Ratio of new products (less than X years old) to full company catalog (%) ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "All private sector",
          strategicObjective: "Innovation"
        },
        {
          text: "R&D percentage of sales from propriety products ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Research and Development time to develop next generation of products ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Sales to selling costs ratio ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Sales and Marketing",
          sectors: "All private sector",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Timeliness and accuracy of price quotations and requests for samples ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Sales",
          sectors: "All private sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Dollars saved by employee suggestions ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Percentage completed timesheets by deadline ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Percentage of hours spent on R&D ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "All sectors",
          strategicObjective: "Innovation"
        },
        {
          text:
            "Percentage of payments (nonpayroll) right amount paid made on time ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Percentage of payments (payroll) right amount paid made on time ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Payroll",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Percentage of payments made by direct credit ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Percentage of requests for help fixed by Help Desk during the first phone call ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Percentage of sales invoices issued on time ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Sales",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Percentage of time program developers have spent on programming (tracking nonproductive time) ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams, especially IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Percentage spent of this year\\u00eds technology capital expenditure ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Accidents per 100,000 hours worked ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Accounting system downtime (8 A.M. to 6 P.M.) ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Adherence to scheduled tasks being performed on time ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Asset utilization rates of major machines ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Availability of Human Resources system ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Average mainframe response time ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Back-to-work programs for staff who have been absent for more than three weeks ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Backup every night this month ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Date of last backup tested at remote site ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Billing accuracy ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Business development expense/administrative expense ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Completion of projects on time and budget (% or $ of total projects) ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Current users of xxx system ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Employees on self-managing teams ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Faults or service requests closed in month ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Initiatives underway based on satisfaction survey ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Investment in research ($) ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "All sectors",
          strategicObjective: "Innovation"
        },
        {
          text: "IT capacity ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Key work carried out by contractors ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Last update of intranet page ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Lost time injury frequency (graph) ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Managers accessing the general ledger (time) ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Manual transaction to automated electronic transaction ratio ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Median patent age in key products ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "All sectors",
          strategicObjective: "Innovation"
        },
        {
          text: "Monthly finance report to the report to CEO ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting or Finance, HR, IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Monthly report to budget holders ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number of accounts payable invoices paid late ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Number of customer calls in test week (e.g., third week of month) ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number of innovations introduced in last 3, 6, 9, 12 months ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "All sectors",
          strategicObjective: "Innovation"
        },
        {
          text: "Number of managers accessing the general ledger ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number of strategic supply relationships ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Procurement",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Number of systems that have been integrated with other company systems ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Number of progress payments due that have not yet been invoiced ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number/percentage of projects completed on time/budget ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Number of management team meetings last week (or number of management meetings planned for next five days) ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number of IT contractors as a percentage of IT employees ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "IT, HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number of critical assets in a catastrophic state ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number of employees ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number of post-project reviews/debriefs ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number of staff trained in first aid ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Healthy and safe work environment"
        },
        {
          text: "Number of times schedule slipped in month ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Orders and reports shipped by express services ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number of overdue reports/documents ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Policy and procedures sections updated this month ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Percent of operational purchases from certified vendors ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "All sectors",
          strategicObjective: "Maintain supplier relationships"
        },
        {
          text:
            "Percent of positive feedback from employees after attending meetings (every meeting rated via intranet) ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Product changes to correct design deficiencies ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Design",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "R&D as a percentage of sales ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Research",
          sectors: "All sectors",
          strategicObjective: "Innovation"
        },
        {
          text: "R&D resources/total resources ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Resolution of queries in same day ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Response time to inquiries and special requests ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Safety measures accidents, days lost by reason ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "HR, all teams",
          sectors: "All sectors",
          strategicObjective: "Healthy and safe work environment"
        },
        {
          text: "Service requests (faults, works requests) logged ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Slow-moving and obsolete inventory ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "All sectors",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Staff who have attended the stress management course ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Staff with > 30 days leave owing ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Stakeholder feedback (on activities, working style, and communication) ",
          frequency: "When survey performed",
          bsc: "Internal process",
          teams: "PR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Number of succession plans for key positions ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Suppliers on the accounts payable ledger ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Time spent on quality improvement activities ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Units/labor hour and labor dollar for direct, indirect, and total labor costs ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Visits to managers planned next week ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Conversion rate of home-buying certificates to mortgage offers ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Branches",
          sectors: "Banking",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Value of retail investment receipts (gross) dollars ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "Banking",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Funds raised ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "Charity",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Consent return rate for rework and resubmission (numbers and dollars) ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Planning",
          sectors: "Construction",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Measure cost of obtaining planning consents ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Planning",
          sectors: "Construction",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Measure number of projects that do not need special consents (client cost benefit) ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Planning",
          sectors: "Construction",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Timeliness of resource consents processing ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Planning",
          sectors: "Construction",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Turnaround time of resource consent applications (days elapsed) ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Planning",
          sectors: "Construction",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Emergency response time ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "Critical services sector",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Claims frequency ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "Insurance",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Claims severity ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Accounting",
          sectors: "Insurance",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Insurance premiums received from new product launches ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Sales and Marketing",
          sectors: "Insurance",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Accomplishment of quality improvement implementation milestones ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "QA",
          sectors: "Manufacturing",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Design cycle time ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Downtime due to different types of equipment failure ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Production control, IT",
          sectors: "Manufacturing",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Engineering changes to off-the-shelf system by reason ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Engineering changes after design completion ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Improvement in productivity (%) ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Number of improvements to products in month ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Inventory system accuracy rates ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Inventory turnover (number) ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Late items as a percentage of average daily production ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Process part-per-million defect rates ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Processes made foolproof ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Processes under statistical control with sufficient capability ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Production schedule delays because of material shortages ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Production set-up/changeover time ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Quality problems attributable to design ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Reduction of parts count on products ",
          frequency: "Quarterly",
          bsc: "Internal process",
          teams: "R&D",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Service factor percent of orders filled ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Technical support costs/unit sold (quality of product and clarity of instructions) ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "QA",
          sectors: "Manufacturing",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Time lost due to schedule changes or deviations from schedule ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Total value of finished products/total production costs ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Operations",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Unplanned versus planned maintenance ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Waste all forms: scrap, rejects, underutilized capacity, idle time, downtime, excess production, etc. ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Waste caused by maintenance tests ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Yield net good product produced ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Production",
          sectors: "Manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Service calls or complaints per unit sold ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "QA",
          sectors: "Retail",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Space productivity sales or production per square foot ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Sales and marketing",
          sectors: "Retail",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Number of leads generated by agents ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "Sales and marketing",
          sectors: "Service",
          strategicObjective: "Increase profitability"
        },
        {
          text: "Reporting errors (e.g., time charged to closed/wrong jobs) ",
          frequency: "Monthly",
          bsc: "Internal process",
          teams: "All teams",
          sectors: "Service",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Percentage of bids or proposals accepted ",
          frequency: "Weekly",
          bsc: "Internal process",
          teams: "Sales",
          sectors: "Service, manufacturing",
          strategicObjective: "Increase profitability"
        },
        {
          text:
            "Percentage of customer-facing employees having on-line access to information about customers (effective communication of accurate information to employee) ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Percentage of employees below age of X ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Percentage of employees who have interacted with customers ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Percentage of employees with tertiary education ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Percentage of managers with satisfactory IT literacy ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "IT",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Percentage of new staff (less than three employees) who have had post-employment interview ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Percentage of performance reviews completed on time ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Percentage of rising stars with mentors ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Percentage of staff performance reviews completed ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR, all teams",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Percentage of contractors to total staff ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Annual rolling average of days training by key team ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Average employee years of service with company ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Desirable place to work"
        },
        {
          text: "Closing the skills matrix gap progress ",
          frequency: "After the performance review round",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Competence development expense/payroll cost ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Employees certified for skilled job functions or positions ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Employees complying with their development plan ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR, training",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Employees terminated for performance, other problems ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Employees that have improved skills during last six months ",
          frequency: "Six monthly",
          bsc: "Learning and growth",
          teams: "HR, training",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Employees with delegated spending authority ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Increase in average grade level of reading and math skills of employees ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR, training",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Investment in new product support and training ($) ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "Sales",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Leadership index (based on responses from a section in the employee survey) ",
          frequency: "Every employee survey (three to four times a year)",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Leadership initiatives targeted to rising stars ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Managers who have had performance management training ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Motivation index (based on responses from a section in the employee survey) ",
          frequency: "Every employee survey (three to four times a year)",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Needs assessment gap required versus actual skills for positions ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR, training",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Number of cumulative work experience (years) in current management team ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Number of current users of X system ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "IT, HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Number of in-house training courses ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced"
        },
        {
          text: "Number of initiatives implemented from the staff survey ",
          frequency: "Weekly after the employee survey",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Number of internal promotions ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Number of staff who have agreed to development plans ",
          frequency: "After the performance review round",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Number of teams with a balanced scorecard (BSC) rollout of a BSC system ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "Balanced scorecard team",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Number of training hours in both external/internal courses ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Number of full time temporary employees (contractors over three months) ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Number of internal applications for job applications closed in month ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Number of level 1 and 2 managers who were promoted internally ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Number of mentoring meetings by each high performer (rising star) ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Number of new staff (less than three months) who attended an induction program ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Number of staff who have attended an induction within four weeks of starting ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Percentage of managers who are women ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Participation in team meetings (% of total team) ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "All teams",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Percentage of cross-trained personnel ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "Production control, training",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Number post project reviews undertaken to ascertain lessons learned ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "Accounting",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Re-skilled employees percentage of workforce requiring re-skilling ",
          frequency: "From staff survey",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text: "Staff trained to use X system ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "IT, HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Staff training attendance ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Staff who have verbal feedback about performance every month ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Number of succession plans for key positions ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Number of suggested improvements from employees by department ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Suggestions made to suggestions implemented ratio ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Innovation"
        },
        {
          text: "Time in training [days/year] (number) ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced"
        },
        {
          text: "Total hours employees spend in mentoring ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "All teams, HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Training days this month ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Training needs outstanding ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Turnover of female staff ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Desirable place to work"
        },
        {
          text: "Turnover of staff by ethnicity ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Number of staff who are aware of new initiative ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Efficient operations"
        },
        {
          text:
            "Number of teams who have undertaken internal user satisfaction surveys ",
          frequency: "Monthly",
          bsc: "Learning and growth",
          teams: "HR",
          sectors: "All sectors",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text:
            "Percentage of staff meeting continuing professional development requirements ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "All teams",
          sectors: "Professional service firms",
          strategicObjective: "Skilled and experienced workforce"
        },
        {
          text: "Number of research papers generated ",
          frequency: "Quarterly",
          bsc: "Learning and growth",
          teams: "R&D",
          sectors: "Tertiary",
          strategicObjective: "Skilled and experienced workforce"
        }
      ]
    };
  },
  methods: {
    select: function() {
      // console.log("Selected", this.selectedFrequency)
    }
  },
  computed: {
    kpis() {
      let _kpis = this.kpis2;
      if (this.selectedFrequency != "") {
        _kpis = this.kpis2.filter(
          kpi => kpi.frequency === this.selectedFrequency
        );
      }
      if (this.selectedBsc != "") {
        _kpis = _kpis.filter(kpi => kpi.bsc === this.selectedBsc);
      }
      if (this.selectedTeam != "") {
        _kpis = _kpis.filter(kpi => kpi.teams === this.selectedTeam);
      }
      if (this.selectedSector != "") {
        _kpis = _kpis.filter(kpi => kpi.sectors === this.selectedSector);
      }
      if (this.selectedStrategicObjective != "") {
        _kpis = _kpis.filter(
          kpi => kpi.strategicObjective === this.selectedStrategicObjective
        );
      }
      this.numKPIs = _kpis.length;
      return _kpis;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  /* display: inline-block; */
  text-align: left;
  margin: 0 10px;
  padding: 10px;
}
a {
  color: #42b983;
}
.results {
  padding-left: 50px;
  padding-top: 20px;
}
.kpi-row {
  border-style: solid;
  border-color: rgb(138, 136, 136);
  padding: 10px;
}
.kpi-title {

}
</style>
